<template>
<div class="chapter">
<div class="inner_page">
<a id="page_viii"></a>
<h2 class="fm-title" id="ack"><span class="bold">Acknowledgements</span></h2>
<p class="noindent"><span class="dropcaps">T</span>hank you to the following for the use of their photographs: Lucy Colgrave, Kyra Foley, Neil Pruitt, Georgie Duane, Gillian Mawson, Linne Matthews and Mirrorpix.</p>
<h3 class="sub_sectionf"><span class="bold">Note on illustrations</span></h3>
<p class="noindent">Unless otherwise acknowledged, the pictures in this book are from the author’s own collection of postcards, magazines and old photograph albums and it has been impossible to determine if any copyright is attached to them. Any infringement of copyright as a result of their publication is entirely unintentional; if any copyright has been infringed, the author extends his apologies to the parties concerned. Should this have happened, please contact the author through the publisher.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 06_Acknowledgements.vue?5a6efd50